import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { applicationConfig } from "@/config";

export const router = createRouter({
    routeTree,
    basepath: `/${applicationConfig.countryCode}`,
    context: {
        auth: undefined,
    },
});

declare module "@tanstack/react-router" {
    interface Register {
        router: typeof router;
    }
}
